import type {
  BasketQtySourceItem,
  DealerRemainsProductType,
} from "../model/types";

// Ключ продавца для остатков СКАД (у них нет sellerDealerId)
export const SKAD_SELLER_KEY = "skad";

// vendorId → ключ продавца → id филиала → количество в корзине
export type RemainsBasketQtyMap = Record<
  string,
  Record<string, Record<string, number>>
>;

// Корзина остатков партнеров приходит вложенной (товар → продавцы) —
// разворачиваем в строки «артикул × продавец»
export const flattenDealerRemainsItems = (
  items: DealerRemainsProductType[],
): BasketQtySourceItem[] =>
  items.flatMap((item) =>
    (item.sellerDealers ?? []).map((seller) => ({
      vendorId: item.vendorId,
      sellerDealerId: seller.sellerDealerId,
      basketFilials: seller.basketFilials,
    })),
  );

export const buildBasketQtyMap = (
  items: BasketQtySourceItem[],
): RemainsBasketQtyMap => {
  const map: RemainsBasketQtyMap = {};

  items.forEach((item) => {
    const sellerKey = item.sellerDealerId ?? SKAD_SELLER_KEY;
    const bySeller = (map[item.vendorId] ??= {});
    const byFilial = (bySeller[sellerKey] ??= {});

    (item.basketFilials ?? []).forEach(({ dealerId, quantity }) => {
      byFilial[dealerId] = (byFilial[dealerId] ?? 0) + quantity;
    });
  });

  return map;
};
